module.exports = __webpack_public_path__ + "assets/img/tit3.6a59d4af.png";